module.exports = __webpack_public_path__ + "img/coinbase-wallet-logo.f34e6351.png";